import Navbar from "@/components/Navbar";
import Hero3D from "@/components/Hero3D";
import StatsRibbon from "@/components/StatsRibbon";
import AboutParimal from "@/components/AboutParimal";
import GoalsSection from "@/components/GoalsSection";
import ServicesSection from "@/components/ServicesSection";
import ComplimentaryMarquee from "@/components/ComplimentaryMarquee";
import Testimonials from "@/components/Testimonials";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import StickyCallButton from "@/components/StickyCallButton";

export default function Home() {
  return (
    <main data-testid="home-page" className="paper-texture min-h-screen">
      <Navbar />
      <Hero3D />
      <StatsRibbon />
      <AboutParimal />
      <GoalsSection />
      <ServicesSection />
      <ComplimentaryMarquee />
      <Testimonials />
      <ContactSection />
      <Footer />
      <StickyCallButton />
    </main>
  );
}
